"use client";

import { Reveal } from "@/components/motion/Reveal";
import { AboutStoryTimeline } from "@/components/home/about-story/AboutStoryTimeline";
import { highlightKeywords } from "@/lib/highlight-keywords";
import { LinkButton } from "@/components/ui/LinkButton";
import type { HomeAboutStoryContent } from "@/lib/api-types";

type AboutStoryContentProps = {
  aboutStory: HomeAboutStoryContent;
};

export function AboutStoryContent({ aboutStory }: AboutStoryContentProps) {
  const {
    eyebrow,
    title,
    missionStatement,
    highlightKeywords: keywords,
    timeline,
    ctaLabel,
    ctaHref,
  } = aboutStory;

  return (
    <div className="flex flex-col justify-center">
      <Reveal>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-primary">
          {eyebrow}
        </p>
        <h2 className="font-display text-3xl font-bold leading-tight text-foreground md:text-4xl lg:text-5xl">
          {title}
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <p className="mt-6 text-lg leading-relaxed text-muted md:mt-8 md:text-xl md:leading-relaxed">
          {highlightKeywords(missionStatement, keywords)}
        </p>
      </Reveal>

      <AboutStoryTimeline items={timeline} />

      <Reveal delay={0.15} className="mt-10">
        <LinkButton href={ctaHref} variant="outline" size="lg">
          {ctaLabel}
        </LinkButton>
      </Reveal>
    </div>
  );
}
